import { Box } from '@material-ui/core';
import React from 'react';

import { Font } from '@/components/shared/components/Font';
import { NemuruDialogButtons } from '@/components/shared/components/NemuruDialog';
import { StandardButton } from '@/components/shared/components/StandardButton';
import { useTranslation } from '@/components/shared/hooks/useTranslation';
import { useScreen } from '@/hooks/useScreen';

export interface DialogStepContentProps {
  titleTextId: string;
  onNext: () => void;
  onPrev?: () => void;
  descriptionTextId?: string;
  nextButtonTextId?: string;
  prevButtonTextId?: string;
  loading?: boolean;
  disabled?: boolean;
  onPrevDisabled?: boolean;
  children?: React.ReactNode;
}

export const DialogStepContent = ({
  titleTextId,
  onNext,
  onPrev,
  descriptionTextId,
  nextButtonTextId = 'CONTINUE',
  prevButtonTextId = 'BACK',
  loading,
  disabled,
  onPrevDisabled = false,
  children,
}: DialogStepContentProps) => {
  const { md } = useScreen();
  const { getTextIdTranslation } = useTranslation();

  const isMobile = !md;

  return (
    <Box display={'flex'} flexDirection={'column'} justifyContent={'space-between'} width={'100%'}>
      <Box zIndex={0}>
        <Box mb={4}>
          <Font variant="h3" color="title">
            {getTextIdTranslation(titleTextId)}
          </Font>
        </Box>
        {descriptionTextId && (
          <Box mb={4}>
            <Font variant={'body2'} color={'textPrimary'}>
              {getTextIdTranslation(descriptionTextId)}
            </Font>
          </Box>
        )}
        {children}
      </Box>
      {isMobile && <Box my={6} />}
      <NemuruDialogButtons>
        {onPrev && (
          <StandardButton onClick={() => onPrev()} disabled={onPrevDisabled}>
            {getTextIdTranslation(prevButtonTextId)}
          </StandardButton>
        )}{' '}
        <StandardButton main disabled={disabled ?? loading} loading={loading} onClick={onNext}>
          {getTextIdTranslation(nextButtonTextId)}
        </StandardButton>
      </NemuruDialogButtons>
    </Box>
  );
};

export type DialogStepProps = Pick<DialogStepContentProps, 'onNext' | 'onPrev'>;
